
<div
  class="menu-item row start-center"
  [ngClass]="getMenuTypeClass(dataSource.menuType)"
  [class.bottom-menu-item]="dataSource.isBottom"
  >
  @if (dataSource.menuItemRouterLink) {
    <a class="row align-items-center grow" [ngClass]="menuItemClassesWithLinks" [routerLink]="dataSource.menuItemRouterLink" [queryParams]="queryParams" (click)="onMenuItemClick()">
      <ng-template [ngTemplateOutlet]="menuItemTemplate"></ng-template>
    </a>
  }
  @if (!dataSource.menuItemRouterLink) {
    <a class="row align-items-center grow" [ngClass]="menuItemClassesNoLinks" (click)="onMenuItemClick()">
      <ng-template [ngTemplateOutlet]="menuItemTemplate"></ng-template>
    </a>
  }
</div>

@if (isExpanded) {
  <div>
    @for (item of dataSource.menuItems; track item) {
      <app-vertical-menu-item
        [dataSource]="item"
      ></app-vertical-menu-item>
    }
  </div>
}

<ng-template #menuItemTemplate>
  @if (dataSource.menuItemIconClass) {
    <div class="column center-center menu-item-icon-container menu-item-content">
      <i class="ri-icon" [ngClass]="dataSource.menuItemIconClass"></i>
    </div>
  }
  <div class="menu-item-name text-overflow"
    [ngClass]="{'menu-item-name-bold': dataSource.level === 0, 'menu-item-name-color': dataSource.level > 0 && isThisMenuItemActive()}"
    [style.padding-left.rem]="getPadding()"
    [title]="dataSource.menuItemName | translate">
    {{ dataSource.menuItemName | translate | customTitleCase:'all'}}
  </div>
  @if (isExpandable()) {
    <div
      class="pr-1"
      (click)="onArrowClick($event)"
      >
      @if (isExpanded) {
        <div>
          <div [ngClass]="{'menu-item-arrow': this.dataSource.isActive }">
            <i class="ri-icon rif-icon_arrow rotated" [ngClass]="{'small-menu-icon': this.dataSource.level > 0, 'module-menu-icon': this.dataSource.level === 0 }"></i>
          </div>
        </div>
      }
      @if (!isExpanded) {
        <div>
          <div [ngClass]="{'menu-item-arrow': this.dataSource.isActive }">
            <i class="ri-icon rif-icon_arrow" [ngClass]="{'small-menu-icon': this.dataSource.level > 0, 'module-menu-icon': this.dataSource.level === 0 }"></i>
          </div>
        </div>
      }
    </div>
  } @else {
    <div [ngClass]="{'menu-item-arrow': this.dataSource.isActive }"></div>
  }
</ng-template>
